export interface Video {
  id: string;
  slug: string;
  title: string;
  description: string;
  category: string;
  thumbnail: string;
  duration: string;
  views: number;
  date: string;
  rating: number;
  tags: string[];
}

export interface VideoCategory {
  slug: string;
  name: string;
  icon: string;
  description: string;
  count: number;
}

export const videoCategories: VideoCategory[] = [
  { slug: 'dianying', name: '电影', icon: 'ri-movie-2-line', description: '最新最热的高清电影大片', count: 1280 },
  { slug: 'dianshiju', name: '电视剧', icon: 'ri-tv-2-line', description: '热门国产剧、韩剧、美剧', count: 960 },
  { slug: 'zongyi', name: '综艺', icon: 'ri-emotion-laugh-line', description: '爆笑综艺、真人秀节目', count: 540 },
  { slug: 'dongman', name: '动漫', icon: 'ri-ghost-line', description: '热血动漫、治愈番剧', count: 830 },
  { slug: 'jilupian', name: '纪录片', icon: 'ri-earth-line', description: '自然人文、历史探秘', count: 320 },
  { slug: 'duanshipin', name: '短视频', icon: 'ri-vidicon-line', description: '精彩短视频、创意内容', count: 2560 },
  { slug: 'tiyu', name: '体育', icon: 'ri-football-line', description: '赛事回放、体育资讯', count: 410 },
  { slug: 'yinyue', name: '音乐', icon: 'ri-music-2-line', description: 'MV、演唱会、音乐节目', count: 680 },
];

export const featuredVideos: Video[] = [
  {
    id: 'v1',
    slug: 'changan-sanwanli',
    title: '长安三万里',
    description: '安史之乱后，高适困守孤城，回忆起与李白的一生交情，展现了大唐由盛转衰的历史画卷和诗人的豪情壮志。',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Epic%20Chinese%20animated%20film%20scene%20with%20ancient%20Tang%20Dynasty%20warriors%20and%20poets%20in%20dramatic%20lighting%2C%20cinematic%20composition%2C%20rich%20golden%20and%20crimson%20tones%2C%20artistic%20film%20poster%20style&width=800&height=450&seq=video-featured-01&orientation=landscape',
    duration: '168分钟',
    views: 2580000,
    date: '2026-07-15',
    rating: 9.1,
    tags: ['动画', '历史', '诗歌'],
  },
  {
    id: 'v2',
    slug: 'liulangdiqiu-3',
    title: '流浪地球3',
    description: '太阳急速老化，人类面临生存危机，全球联合政府启动"流浪地球计划"，展开一段跨越星河的冒险旅程。',
    category: 'dianying',
    thumbnail: 'https://readdy.ai/api/search-image?query=Futuristic%20sci-fi%20movie%20scene%20with%20massive%20space%20engines%20on%20Earth%20surface%2C%20dramatic%20orange%20and%20blue%20lighting%2C%20epic%20cinematic%20scale%2C%20movie%20poster%20aesthetic&width=800&height=450&seq=video-featured-02&orientation=landscape',
    duration: '152分钟',
    views: 3120000,
    date: '2026-06-28',
    rating: 8.8,
    tags: ['科幻', '冒险', '灾难'],
  },
  {
    id: 'v3',
    slug: 'kuangbiao-2',
    title: '狂飙2：正义之路',
    description: '一线刑警安欣与黑恶势力展开长达二十年的生死较量，在扫黑除恶专项斗争中最终揭开层层黑幕。',
    category: 'dianshiju',
    thumbnail: 'https://readdy.ai/api/search-image?query=Intense%20Chinese%20crime%20drama%20scene%20with%20two%20police%20officers%20in%20dark%20alley%2C%20moody%20atmospheric%20lighting%2C%20noir%20cinematography%2C%20suspenseful%20drama%20poster&width=800&height=450&seq=video-featured-03&orientation=landscape',
    duration: '45分钟/集',
    views: 1890000,
    date: '2026-08-01',
    rating: 9.3,
    tags: ['刑侦', '扫黑', '悬疑'],
  },
  {
    id: 'v4',
    slug: 'chengfengpolang-5',
    title: '乘风破浪的姐姐 第五季',
    description: '30位30+女艺人重新出发，通过舞台竞演展现成熟女性的魅力与力量，诠释不设限的人生态度。',
    category: 'zongyi',
    thumbnail: 'https://readdy.ai/api/search-image?query=Glamorous%20Chinese%20variety%20show%20stage%20with%20female%20performers%20in%20elegant%20costumes%2C%20dramatic%20stage%20lighting%2C%20golden%20and%20warm%20tones%2C%20concert%20atmosphere&width=800&height=450&seq=video-featured-04&orientation=landscape',
    duration: '120分钟/期',
    views: 1420000,
    date: '2026-07-20',
    rating: 8.5,
    tags: ['综艺', '竞演', '女性'],
  },
  {
    id: 'v5',
    slug: 'huyao-xiaohongniang',
    title: '狐妖小红娘·镜花缘篇',
    description: '涂山苏苏与白月初在续缘之路上遭遇全新挑战，镜花水月之中，前世的记忆碎片逐渐拼凑出惊天秘密。',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Beautiful%20Chinese%20anime%20style%20fox%20spirit%20girl%20in%20traditional%20red%20dress%20with%20magical%20elements%2C%20cherry%20blossoms%2C%20soft%20ethereal%20lighting%2C%20fantasy%20illustration&width=800&height=450&seq=video-featured-05&orientation=landscape',
    duration: '24分钟/集',
    views: 980000,
    date: '2026-07-10',
    rating: 9.4,
    tags: ['国漫', '玄幻', '爱情'],
  },
];

export const allVideos: Video[] = [
  ...featuredVideos,
  {
    id: 'v6',
    slug: 'diyi-xulishi',
    title: '第一序列',
    description: '核战后废土世界，主角任小粟凭借特殊能力在废墟中生存，揭开隐藏在序列背后的惊天秘密。',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Post-apocalyptic%20Chinese%20anime%20scene%20with%20ruined%20cityscape%2C%20lone%20survivor%20silhouette%2C%20dusty%20orange%20sky%2C%20atmospheric%20wasteland%2C%20animated%20film%20style&width=800&height=450&seq=video-all-06&orientation=landscape',
    duration: '22分钟/集',
    views: 720000,
    date: '2026-08-05',
    rating: 9.0,
    tags: ['国漫', '科幻', '末世'],
  },
  {
    id: 'v7',
    slug: 'diyu-zuguo',
    title: '地球脉动·祖国篇',
    description: '从青藏高原到南海之滨，从大兴安岭到帕米尔高原，用4K超高清镜头记录中国最壮美的自然奇观。',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Stunning%20aerial%20landscape%20of%20Chinese%20mountains%20at%20sunrise%2C%20layered%20misty%20peaks%2C%20golden%20light%2C%20nature%20documentary%20cinematography%2C%20breathtaking%20vista&width=800&height=450&seq=video-all-07&orientation=landscape',
    duration: '50分钟/集',
    views: 1850000,
    date: '2026-06-15',
    rating: 9.7,
    tags: ['自然', '地理', '4K'],
  },
  {
    id: 'v8',
    slug: 'yuzhouchuangzuo',
    title: '宇宙创造之旅',
    description: '跟随NASA与ESA的最新探索成果，从大爆炸到黑洞，从系外行星到暗物质，揭开宇宙的神秘面纱。',
    category: 'jilupian',
    thumbnail: 'https://readdy.ai/api/search-image?query=Cosmic%20nebula%20and%20galaxy%20scene%20with%20vibrant%20purple%20and%20golden%20stardust%2C%20deep%20space%20aesthetic%2C%20scientific%20visualization%2C%20astronomy%20documentary%20style&width=800&height=450&seq=video-all-08&orientation=landscape',
    duration: '55分钟/集',
    views: 930000,
    date: '2026-05-20',
    rating: 9.5,
    tags: ['宇宙', '科学', '探索'],
  },
  {
    id: 'v9',
    slug: 'meishi-tanxian',
    title: '街头美食探险记',
    description: '走遍全国34个省市自治区，尝遍各地特色街头小吃，用镜头记录最地道的美食文化和人间烟火。',
    category: 'duanshipin',
    thumbnail: 'https://readdy.ai/api/search-image?query=Mouthwatering%20Chinese%20street%20food%20scene%20with%20steaming%20noodles%20and%20grilled%20skewers%2C%20bustling%20night%20market%2C%20warm%20ambient%20lighting%2C%20food%20documentary%20style&width=800&height=450&seq=video-all-09&orientation=landscape',
    duration: '8分钟/集',
    views: 1560000,
    date: '2026-08-08',
    rating: 9.2,
    tags: ['美食', '旅行', '文化'],
  },
  {
    id: 'v10',
    slug: 'nba-zongjuesai',
    title: 'NBA总决赛·全程回放',
    description: '2026年NBA总决赛全程高清回放，见证冠军诞生的每一个精彩瞬间，包含专业解说与赛后分析。',
    category: 'tiyu',
    thumbnail: 'https://readdy.ai/api/search-image?query=Intense%20basketball%20game%20moment%20with%20players%20dunking%2C%20packed%20arena%20with%20dramatic%20spotlights%2C%20sports%20photography%20style%2C%20dynamic%20action%20shot&width=800&height=450&seq=video-all-10&orientation=landscape',
    duration: '150分钟',
    views: 2200000,
    date: '2026-06-25',
    rating: 9.0,
    tags: ['篮球', 'NBA', '赛事'],
  },
  {
    id: 'v11',
    slug: 'zhongguo-hao-shengyin',
    title: '中国好声音·2026',
    description: '全新一季中国好声音重磅回归，四位重量级导师坐镇，寻找下一个华语乐坛超级新星。',
    category: 'yinyue',
    thumbnail: 'https://readdy.ai/api/search-image?query=Music%20talent%20show%20stage%20with%20spotlight%20on%20singer%2C%20red%20rotating%20chairs%2C%20dramatic%20concert%20lighting%2C%20grand%20stage%20production&width=800&height=450&seq=video-all-11&orientation=landscape',
    duration: '90分钟/期',
    views: 1680000,
    date: '2026-07-08',
    rating: 8.6,
    tags: ['音乐', '选秀', '竞演'],
  },
  {
    id: 'v12',
    slug: 'zhu-xian-donghua',
    title: '诛仙·动画重制版',
    description: '经典仙侠小说《诛仙》动画重制，精美国风画面再现张小凡的修仙传奇，碧瑶与陆雪琪的情感纠葛。',
    category: 'dongman',
    thumbnail: 'https://readdy.ai/api/search-image?query=Ethereal%20Chinese%20fantasy%20landscape%20with%20floating%20mountains%20and%20ancient%20temples%2C%20celestial%20light%20rays%2C%20traditional%20ink%20painting%20style%20blended%20with%20anime&width=800&height=450&seq=video-all-12&orientation=landscape',
    duration: '25分钟/集',
    views: 850000,
    date: '2026-07-25',
    rating: 9.1,
    tags: ['国漫', '仙侠', '经典'],
  },
];